class ErrorController{
    /*@ngInject*/
    constructor($window){
        this.$window = $window;
    }
    $onInit(){

    }
    refresh(){
        this.$window.location.reload();
    }
}

export default ErrorController;


// WEBPACK FOOTER //
// ./public/app/error/error.controller.js